import * as gfunctions from '../../../js/generalFunctions';

CCL.HourPromo = {
  autoload: [
    ['initialLoad', $('.promo48Hours').length > 0]
  ],

  allData: {},

  initialLoad() {
    $('.promo48Hours').click((e) => {
      this.loadJsonModalData();
    });
  },

  loadJsonModalData() {
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/48-hour-promotion/48-hour-promotion.json';
    } else {
      ajaxUrl = '/shop/promotion/getProductsForPromotion';
    }
    const dataObj = {
      discount: $('.promo48Hours').data('discount')
    };
    const token = $('#csrfSessionToken').data('csrf');
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      headers: {
        CSRFToken: token
      },
      data: dataObj
    }).done((response) => {
      this.loadHtmlModalData(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  loadHtmlModalData(jsonData) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/48-hour-promotion/48-hour-promotion.html'
    }).done((response) => {
      $.each(jsonData.portCards, (index, value) => {
        $.each(value.productCards, (i, v) => {
          v.active = i === 0;
          v.priceString = this.getPriceString(v);
        });
        gfunctions.hideLoader();
      });
      this.allData = jsonData;
      const tempHtml = response.replace('{{$whyBookSection}}', this.allData.definiteTimePromoWhyBookDescription);
      const html = gfunctions.createDynamicHTML(tempHtml, this.allData);
      $('#dynamicPromotions').empty().append(html);
      gfunctions.showModal('promo48Hours');
      this.loadCarousel();
      this.activateClickEvents();
      this.modalEvents();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  },

  getPriceString(obj) {
    if (obj.salesPerUnitDescription) {
      return [{
        priceVal: obj.adultPriceTo,
        priceText: obj.salesPerUnitDescription
      }];
    } else if (obj.adultPriceTo === obj.childPriceTo) {
      return [{
        priceVal: obj.adultPriceTo,
        priceText: 'Person'
      }];
    }
    return [{
      priceVal: obj.adultPriceTo,
      priceText: 'Adult, '
    },
    {
      priceVal: obj.childPriceTo,
      priceText: 'Child'
    }];
  },

  activateClickEvents() {
    $('#addExcPromotions').click((e) => {
      this.ajaxOnSubmit();
    });
  },

  loadCarousel() {
    const owl = $('.owl-carousel');
    owl.owlCarousel({
      loop: false,
      nav: true,
      margin: 0,
      items: 1,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      onDragged: (e) => {
        console.log('dragged');
        console.dir(e);
      }
    });

    setTimeout(() => {
      $('.owl-item.active .c-product-card').attr('tabindex', '0').attr('data-tabindex', '0');
      $('.c-product-card').addClass('ccl-negative-outline');

      this.bulletsContext();

      // On next item click
      $('.owl-dots button').click((e) => {
        const currentTarget = $(e.currentTarget);
        setTimeout(() => {
          this.calculatePageBullet(currentTarget.parent());
        }, 200);
      });
    }, 500);

    const modalId = $('#promo48Hours');
    modalId.find('.owl-carousel').each((index, e) => {
      const carouselTop = $(e);

      // Arrow Order
      const clonedObj = carouselTop.find('.owl-nav').clone();
      clonedObj.prependTo(carouselTop);

      // Arrow Purge
      carouselTop.find('.owl-nav button.owl-next').first().remove();
      carouselTop.find('.owl-nav button.owl-prev').last().remove();
    });

    $('.owl-carousel').keydown((event) => {
      const carouselTop = $(event.currentTarget);
      if (event.keyCode === 37 || event.keyCode === 38) {
        setTimeout(() => {
          const elem = carouselTop.find('.owl-item.active .c-product-card');
          this.setElements(elem);
          this.changeActive(elem[0].id);
          this.enablePrevArrow(carouselTop);
          this.calculatePageBullet(carouselTop.find('.owl-dots'));
        }, 100);
      } else if (event.keyCode === 39 || event.keyCode === 40) {
        setTimeout(() => {
          const elem = carouselTop.find('.owl-item.active .c-product-card');
          this.setElements(elem);
          this.changeActive(elem[0].id);
          this.enablePrevArrow(carouselTop);
          this.calculatePageBullet(carouselTop.find('.owl-dots'));
        }, 100);
      }
    });

    // On next item click
    $('.owl-next').click((e) => {
      const carouselTop = $(e.currentTarget).parent().parent();
      setTimeout(() => {
        const elem = $(`#${e.currentTarget.parentElement.offsetParent.id} .owl-item.active .c-product-card`);
        this.setElements(elem);
        this.changeActive(elem[0].id);
        this.enablePrevArrow(carouselTop);
        this.calculatePageBullet(carouselTop.find('.owl-dots'));
      }, 100);
    });

    // On previous item click
    $('.owl-prev').click((e) => {
      const carouselTop = $(e.currentTarget).parent().parent();
      carouselTop.trigger('prev.owl.carousel');
      setTimeout(() => {
        const elem = $(`#${e.currentTarget.parentElement.offsetParent.id} .owl-item.active .c-product-card`);
        this.setElements(elem);
        this.changeActive(elem[0].id);
        this.enablePrevArrow(carouselTop);
        this.calculatePageBullet(carouselTop.find('.owl-dots'));
      }, 100);
    });
  },

  calculatePageBullet(dots) {
    const items = dots.children();
    const n = items.length;

    items.attr('tabindex', '0').attr('data-tabindex', '0');

    if (n > 0) {
      items.each((index2, i) => {
        const bullet = $(i);
        let current = '';
        if (bullet.hasClass('active')) {
          current = '- Current slide';
        }
        bullet.attr('aria-label', `Slide ${index2 + 1} of ${n} ${current}`);
      });
    }
  },

  bulletsContext() {
    $('.owl-dots').each((index, e) => {
      const dots = $(e);
      this.calculatePageBullet(dots);
    });

    // On next item click
    $('.owl-dots button').click((e) => {
      const currentTarget = $(e.currentTarget);
      const carouselTop = currentTarget.parent().parent();
      setTimeout(() => {
        this.calculatePageBullet(currentTarget.parent());
        this.enablePrevArrow(carouselTop);
      }, 200);
    });
  },

  enablePrevArrow(carouselTop) {
    if (carouselTop.find('.owl-item').first().not('active')) {
      carouselTop.find('.owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
    }
    if (carouselTop.find('.owl-item').first().hasClass('active')) {
      carouselTop.find('.owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
    }
  },

  setElements(elem) {
    setTimeout(() => {
      elem.attr('tabindex', '0').attr('data-tabindex', '0');
      elem.focus();
    }, 500);
  },

  changeActive(id) {
    $.each(this.allData.portCards, (index, value) => {
      if (value.productCards.filter(x => x.variantId === id).length) {
        $.each(value.productCards, (i, v) => {
          v.active = v.variantId === id;
        });
      }
    });

    this.ajaxOnChange();
  },

  ajaxOnChange() {
    const ajaxData = this.getActive();
    const discountApplied = this.allData.productDiscountSummary.percentageDiscount;
    const token = $('#csrfSessionToken').data('csrf');
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      data: JSON.parse(JSON.stringify({ productIds: ajaxData, discount: discountApplied })),
      url: '/shop/promotion/getDiscountSummaryForPromotion',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.updateHeaderCartWidget(response);
      this.updateTotal(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error Occured');
    });
  },

  updateTotal(response) {
    const { productDiscountSummary } = response;
    $('.subtotal-div .subtotal')[0].firstElementChild.nextElementSibling.innerHTML = `$${productDiscountSummary.subTotal}`;
    $('.subtotal-div .discount')[0].firstElementChild.nextElementSibling.innerHTML = `${productDiscountSummary.percentageDiscount}%`;
    $('.subtotal-div .saving')[0].firstElementChild.nextElementSibling.innerHTML = `-$${productDiscountSummary.savings}`;
    $('.subtotal-div .total')[0].firstElementChild.nextElementSibling.innerHTML = `$${productDiscountSummary.totalPrice}`;
  },


  ajaxOnSubmit() {
    gfunctions.showLoader();
    const ajaxData = this.getActive();
    const token = $('#csrfSessionToken').data('csrf');
    gfunctions.showLoader();
    $.ajax({
      type: 'POST',
      data: JSON.parse(JSON.stringify({ productIds: ajaxData })),
      url: '/shop/promotion/cart/addToCart',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideModal('promo48Hours');
      gfunctions.hideLoader();
      gfunctions.updateHeaderCartWidget(response);
      $('.c-alert-banner-courtesy-hold-notification.show').hide();
      console.log('Data submit success');
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error Occured');
      gfunctions.hideLoader();
    });
  },

  getActive() {
    const tempArr = [];
    $.each(this.allData.portCards, (index, value) => {
      const isActive = value.productCards.filter(x => x.active);
      if (isActive.length) {
        tempArr.push(isActive[0].variantId);
      }
    });

    return tempArr;
  },

  modalEvents() {
    const modalEl = $('#promo48Hours');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-48-hour-promotion/c-48-hour-promotion.js